import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AccessDeniedService {

  private _message: string;

  public get message() : string {
    return this._message;
  }

  constructor(private router: Router) { }

  private failWith(message: string): void {
    this._message = message;
    this.router.navigateByUrl('/acces-refuse');
  }

  public unauthenticated(): void {
    this.failWith("message.unauthenticated");
  }

  public unauthorized(): void {
    this.failWith("message.unauthorized");
  }

  public expiredSession(): void {
    this.failWith("message.expired-session");
  }
}
